import { useMemo } from 'react';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import { DealDropdown } from '@dealstack/frontend/app/pages/Project/DealDashboard/DealDropdown/DealDropdown';
import { SummaryDealExtendedTct, SummaryDealTct } from '@dealstack/shared/lib/generated';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useDealstackFeatureFlag } from '@dealstack/frontend/shared/hooks/useDealstackFeatureFlag/useDealstackFeatureFlag.hook';
import { FEATURE_FLAG } from '@dealstack/shared/lib/common/featureFlag';
import { generatePath } from 'react-router-dom';

interface Props {
	dealId?: string;
	deal?: SummaryDealExtendedTct;
	deals?: SummaryDealTct[];
}

export const useMessagesDealSwitcher = ({ dealId, deal, deals }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	const { value: inPageFeatureFlag } = useDealstackFeatureFlag(
		FEATURE_FLAG.IN_PAGE_BREADCRUMBS_AND_QUICK_SWITCH_MENU
	);

	const breadcrumbs = useMemo(() => {
		if (inPageFeatureFlag) {
			return [
				{
					name: deal?.name ?? 'Deal',
					url: generatePath(ROUTES.DEAL, { dealId: dealId ?? '' }),
					element: (
						<DealDropdown
							key="deal-dropdown"
							currentDealId={dealId}
							deals={deals ?? []}
						/>
					),
				},
			];
		}

		return [
			{
				name: tCommonUi('breadcrumbs.my_deals'),
				url: ROUTES.DASHBOARD,
			},
			{
				name: deal?.name ?? 'Deal',
				url: generatePath(ROUTES.DEAL, { dealId: dealId ?? '' }),
				element: (
					<DealDropdown key="deal-dropdown" currentDealId={dealId} deals={deals || []} />
				),
			},
			{
				name: 'Messages',
				url: `#`,
			},
		];
	}, [deal?.name, dealId, deals]);

	useBreadcrumbs(breadcrumbs, {
		skipFirst: true,
	});
};
